/**
 * Helpers for the super admin dashboard. The API sends money in integer
 * CENTS; everything here converts only for display.
 */
import { money, count, delta, pct } from '../RestaurantDashboard/format'

export const $ = cents => (cents == null ? '—' : money(Number(cents) / 100))
export const $short = cents => {
  if (cents == null) return '—'
  const d = Number(cents) / 100
  if (Math.abs(d) >= 100000) return `$${(d / 1000).toFixed(0)}k`
  if (Math.abs(d) >= 10000) return `$${(d / 1000).toFixed(1)}k`
  return money(d)
}
export { count, delta, pct }
export const pctOf = (part, whole) => (whole ? `${((Number(part) / Number(whole)) * 100).toFixed(1)}%` : '—')
export const rate = r => (r == null ? '—' : `${(r * 100).toFixed(1)}%`)

export const PRESETS = [
  { key: 'today', label: 'Today' },
  { key: '7', label: '7 days' },
  { key: '30', label: '30 days' },
  { key: 'thisMonth', label: 'This month' },
  { key: 'lastMonth', label: 'Last month' },
  { key: 'custom', label: 'Custom' },
  { key: 'all', label: 'All time' }
]

export const COMPARE_OPTIONS = [
  { key: 'previous', label: 'vs previous period' },
  { key: 'year', label: 'vs same period last year' },
  { key: 'none', label: 'No comparison' }
]

export const CHANNEL_OPTIONS = [
  { key: 'ALL', label: 'All channels' },
  { key: 'ONLINE', label: 'Online (RushMyFood)' },
  { key: 'LEGACY', label: 'Legacy app' },
  { key: 'PARTNER', label: 'Partner (DoorDash, Uber Eats…)' },
  { key: 'EMBED', label: 'Embed links' },
  { key: 'INSTORE', label: 'In-store (POS)' }
]

export const FULFILLMENT_OPTIONS = [
  { key: 'ALL', label: 'All fulfillment' },
  { key: 'DELIVERY', label: 'Delivery' },
  { key: 'PICKUP', label: 'Pickup' }
]

export const CHANNEL_LABEL = { ONLINE: 'Online', EMBED: 'Embed', INSTORE: 'In-store', LEGACY: 'Legacy app', PARTNER: 'Partner' }
export const FULFILL_LABEL = { DELIVERY: 'Delivery', PICKUP: 'Pickup', DINE_IN: 'Dine-in' }

export const NOT_TRACKED = 'Not tracked yet'

/** "vs previous 30 days" etc. for the delta labels. */
export function compareText(d) {
  if (!d || !d.previous) return ''
  if (d.compare === 'year') return 'vs same period last year'
  const n = Math.round((Date.parse(`${d.to}T00:00:00Z`) - Date.parse(`${d.from}T00:00:00Z`)) / 86400000) + 1
  return n === 1 ? 'vs previous day' : `vs previous ${n} days`
}
